// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* make sure to keep these in sync with other constants,
e.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */

/* layout contants from \`layout-constants.js\` */

/*
    Contains constants for the z-index values of elements that are part of the global stack context.
    In other words, z-index values that are "inside" a component are not added here.
    This prevents conflicts between identical z-index values in different components.
*/

/* Toolbox z-index: 40; set in scratch-blocks */

/* tooltips should go over add buttons if they overlap */

/* monitors go over add buttons */

/* "ask" block text input goes above monitors */

/* menu-bar should go over monitors, alerts and tutorials */

/* behind menu-bar */

/* Block drag z-index: 1000; default 50 is overriden in blocks.css */

/* so it is draggable into other panes */

/* behind modals */

/* behind modals */

/* in most interfaces, the context menu is always on top */

.cursors_layer_MOFz1 {
    position: absolute;
    inset: 0;
    z-index: 49;
    overflow: hidden;
    pointer-events: none;
}

.cursors_cursor_qXxEY {
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    align-items: flex-start;
    pointer-events: none;
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
}

.cursors_name_v8SPT {
    margin-top: 1rem;
    max-width: 10rem;
    padding: 0.2rem 0.4rem;
    border-radius: calc(0.5rem / 2);
    color: white;
    font-size: 0.75rem;
    line-height: 1rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    unicode-bidi: plaintext;
}
`, "",{"version":3,"sources":["webpack://./src/components/dash-collaboration-cursors/cursors.css"],"names":[],"mappings":"AAAA;sDACsD;;AAEtD,+CAA+C;;AAE/C;;;;CAIC;;AAED,+CAA+C;;AAE/C,wDAAwD;;AAExD,iCAAiC;;AAEjC,+CAA+C;;AAE/C,2DAA2D;;AAE3D,oBAAoB;;AAEpB,oEAAoE;;AAEpE,wCAAwC;;AAExC,kBAAkB;;AAElB,kBAAkB;;AAElB,0DAA0D;;AAE1D;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,aAAa;IACb,uBAAuB;IACvB,oBAAoB;IACpB,2DAA2D;AAC/D;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB;IACtB,+BAA+B;IAC/B,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,uBAAuB;AAC3B","sourcesContent":["/* make sure to keep these in sync with other constants,\ne.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */\n\n/* layout contants from `layout-constants.js` */\n\n/*\n    Contains constants for the z-index values of elements that are part of the global stack context.\n    In other words, z-index values that are \"inside\" a component are not added here.\n    This prevents conflicts between identical z-index values in different components.\n*/\n\n/* Toolbox z-index: 40; set in scratch-blocks */\n\n/* tooltips should go over add buttons if they overlap */\n\n/* monitors go over add buttons */\n\n/* \"ask\" block text input goes above monitors */\n\n/* menu-bar should go over monitors, alerts and tutorials */\n\n/* behind menu-bar */\n\n/* Block drag z-index: 1000; default 50 is overriden in blocks.css */\n\n/* so it is draggable into other panes */\n\n/* behind modals */\n\n/* behind modals */\n\n/* in most interfaces, the context menu is always on top */\n\n.layer {\n    position: absolute;\n    inset: 0;\n    z-index: 49;\n    overflow: hidden;\n    pointer-events: none;\n}\n\n.cursor {\n    position: absolute;\n    top: 0;\n    left: 0;\n    display: flex;\n    align-items: flex-start;\n    pointer-events: none;\n    font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n}\n\n.name {\n    margin-top: 1rem;\n    max-width: 10rem;\n    padding: 0.2rem 0.4rem;\n    border-radius: calc(0.5rem / 2);\n    color: white;\n    font-size: 0.75rem;\n    line-height: 1rem;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    unicode-bidi: plaintext;\n}\n"],"sourceRoot":""}]);
// Exports
export var layer = `cursors_layer_MOFz1`;
export var cursor = `cursors_cursor_qXxEY`;
export var name = `cursors_name_v8SPT`;
export default ___CSS_LOADER_EXPORT___;
